<template>
  <div v-if="person.compare_tags" class="graph">
    <svg v-if="!preview" preserveAspectRatio="none" x="0px" y="0px" :viewBox="`0 0 1200 ${svgProcent}`" :enableBackground=
    "`new 0 0 1200 ${svgProcent}`">

      <linearGradient :id="`SVGID_MAIN_${isUserPage()}`" gradientTransform="rotate(90)">
        <stop offset="0%" style="stopColor: rgb(252, 100, 10)"></stop>
        <stop offset="100%" style="stopColor:rgb(237, 53, 100)"></stop>
      </linearGradient>

      <g v-for="category, key in tags">
        <rect :ref="`rect${key}`" :style="`transform: scaleY(${getScale(getCurrentCategoryValue(category))})`" :x="(301 * key)" :y="getHeight()" :fill="`url(#SVGID_MAIN_${isUserPage()})`" width="301" :height="graphHeight"/>
      </g>
    </svg>

    <svg :class="`graph-main graph-main-${!personBusy ? 'active' : ''}`" preserveAspectRatio="none" x="0px" y="0px" :viewBox="`0 0 1200 ${svgProcent}`" :enableBackground=
    "`new 0 0 1200 ${svgProcent}`">

      <g v-for="category, key in tags">
        <linearGradient :id="`Like_${person.id}_${key}`" gradientTransform="rotate(90)">
          <stop offset="0%" :style="`stopColor: ${getTopColor(getCurrentCategoryValue(category))}`"/>
          <stop offset="100%" :style="`stopColor:${getBottomColor(getCurrentCategoryValue(category))}`"/>
        </linearGradient>
        <rect :ref="`rect${key}`" :style="`transform: scaleY(${getScale(getCurrentCategoryValue(category))})`" :x="(301 * key)" :y="getHeight()" :fill="`url(#Like_${person.id}_${key})`" width="301" :height="graphHeight"/>
      </g>
    </svg>

    <div v-if="!preview" :class="`graph--stat graph--stat-${rects[0] > 0 && !personBusy ? 'active' : ''}`">
      <router-link :to="`/rate/${category.tag}/`" :style="`opacity: ${!personBusy ? 1 : 0}; bottom: ${getHeightGraph(category)}px`" :class="`graph--stat-cat graph--stat-cat-${key}`" v-for="category, key in tags" :key="key">
        <h2 class="graph--compare">{{ getCurrentCategoryValue(category) }}%</h2>
        <p>{{ getCategoryBySlug(category) || 'Тест'}}</p>
        <p :class="`graph--stat-test graph--stat-test-${area === key && (!personCurrent.id || person.id == personCurrent.id) ? 'active' : '' }`">
          <router-link :to="`/rate/${category.tag}/`">Пройти тест</router-link>
        </p>
      </router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import findObj from '@/utils/objects';
import colorLibrary from '@/utils/colorLibrary';

export default {
  name: 'graph',
  props: ['preview'],
  computed: mapGetters({
    dev: 'dev',
    tags: 'tags',
    person: 'person',
    personBusy: 'personBusy',
    personCurrent: 'personCurrent',
  }),
  data() {
    return {
      area: null,
      svgProcent: 400,
      graphHeight: 200,
      standard: 0,
      gradient: {
        up: { r: 252, g: 120, b: 0 },
        down: { r: 255, g: 85, b: 0 },
      },
      rects: [0, 0, 0, 0],
    };
  },
  mounted() {
    window.addEventListener('resize', this.calcRects);
    window.addEventListener('mousemove', this.mouseMove);
  },
  watch: {
    person() {
      if (this.person.id) {
        setTimeout(() => {
          this.calcRects();
        }, 500);
      }
    },
  },
  beforeDestro() {
    window.removeEventListener('resize', this.calcRects);
    window.removeEventListener('mousemove', this.mouseMove);
  },
  methods: {
    getTopColor(coeff) {
      return colorLibrary(coeff).top;
    },

    getBottomColor(coeff) {
      return colorLibrary(coeff).bottom;
    },

    getScale(coeff) {
      return 1 + (coeff / 140);
    },

    getHeight() {
      return this.svgProcent - this.graphHeight;
    },

    getHeightGraph(category) {
      let height = window.innerHeight;
      if (height < 800) {
        height = 800;
      }
      const graphMaxWrap = (height * 80) / 100;
      const graphMax = graphMaxWrap / 2;
      const scale = this.getScale(this.getCurrentCategoryValue(category));
      return (graphMax * scale) - 80;
    },

    getCategoryBySlug(category) {
      const tag = findObj(this.tags, category.tag, 'tag');
      return tag.name;
    },

    getCurrentCategoryValue(category) {
      let value = null;
      for (let cat = 0; cat < this.person.compare_tags.length; cat += 1) {
        const catCurrent = this.person.compare_tags[cat];
        if (category.tag === catCurrent.tag) {
          value = catCurrent.value;
        }
      }
      return value || this.standard;
    },

    calcRects() {
      for (let rect = 0; rect < this.rects.length; rect += 1) {
        const rectRef = this.$refs[`rect${rect}`];
        if (rectRef && rectRef[0]) {
          Vue.set(this.rects, rect, rectRef[0].getBoundingClientRect().height || 1);
        }
      }
    },

    isUserPage() {
      return this.$route.params.user;
    },

    mouseMove(e) {
      this.area = Math.floor(e.pageX / (window.innerWidth / 4));
    },
  },
};
</script>

<style>

$min-height: 0px;
.graph{
  position: absolute;
  bottom: -1px;
  height: 80%;
  width: 100%;
  left: 0;

  &-main{
    transition: opacity .3s ease-in-out;
    opacity: 0;
    &-active{
      opacity: 1;
    }
  }

  svg{
    transform: translate3d(0,0,0);
    position: absolute;
    min-height: $min-height;
    height: 100%;
    width: 100%;
      rect{
        stroke: rgba(255, 255, 255, 0.42);
        transition: all .3s ease-in-out;
        transform-origin: bottom;
        stroke-width: .5px;
        .app-ie &{
          transform: none !important;
        }
      }
      text{
        text-anchor: middle;
      }
  }

  &--compare{
    margin-bottom: 5px;
    font-family: Flai;
    font-size: 160%;
    @media (max-width: 700px) {
      font-size: 150%;
    }
  }

  &--category{
    font-size: 80%;
    @media (max-width: 700px) {
      font-size: 100%;
    }
  }

  &--stat{
    transition: opacity .2s ease-in-out;
    position: absolute;
    min-height: $min-height;
    width: 100%;
    height: 90%;
    opacity: 0;
    bottom: 0;

    &-active{
      transition: opacity .2s ease-in-out;
      transition-delay: .3s;
      opacity: 1;
    }

    @media (max-width: 700px){
       font-size: 90%;
    }
    @media (max-width: 500px){
       font-size: 80%;
    }
    &-test{
      transition: opacity .3s ease-in-out;
      white-space: nowrap;
      position: relative;
      margin-top: 35px;
      opacity: 0;
      top: 5px;
      &-active{
        opacity: 1;
      }
      a{
        color: white;
        border-bottom-color: rgba(255,255,255,.3);
      }
      .app-ie &{
        transform: none !important;
      }
    }
    &-cat{
      transition: transform .3s ease-in-out;
      display: inline-block;
      position: absolute;
      text-align: center;
      border-bottom: 0;
      min-height: 80px;
      padding: 30px;
      z-index: 99;
      width: 25%;
      bottom: 47%;
      &,
      &:hover{
        color: black;
      }

      @media (max-height: 900px){
        bottom: 45.5%;
      }
      @media (max-height: 780px){
        bottom: 42%;
      }
      @media (max-height: 740px){
        bottom: 39%;
      }
      @media (max-height: 700px){
        bottom: 36%;
      }

      @media (min-height: 1300px) {
        bottom: 50%;
      }

      &:after{
        position: absolute;
        cursor: pointer;
        display: block;
        height: 100vh;
        width: 100%;
        content: '';
        left: 0;
        top: 0;
        @media (max-height: 900px){
          height: 80vh;
        }
        @media (max-height: 700px){
          height: 55vh
        }
      }

      @media (max-width: 500px){
        padding: 30px 5px;
      }

      &-0{
        left: 0;
      }
      &-1{
        left: 25%;
      }
      &-2{
        left: 50%;
      }
      &-3{
        left: 75%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Graph.vue?5fca3812